import { createSvgComponent } from "../../icon/createSvgComponent";
import Youtube from "@core/__generated__/icon/figma/youtube.svg";
export default createSvgComponent(Youtube);